(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dealer-registration-form"] && !Shopify.designMode) return;
  try {
    (function () {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.classList.contains('dealer-registration-form__form')) return;

      var bodyTextarea = form.querySelector('.dealer-registration-form__body-hidden');
      if (!bodyTextarea) return;

      var fields = form.querySelectorAll('[data-dealer-field]');
      var lines = [];

      fields.forEach(function (field) {
        var includeInEmail = field.getAttribute('data-include-in-email');
        if (includeInEmail === 'false') return;

        var label = field.getAttribute('data-email-label') || field.getAttribute('data-dealer-field') || '';
        var value = field.value ? field.value.trim() : '';

        if (label) {
          lines.push(label + ': ' + value);
        }
      });

      bodyTextarea.value = lines.join('\n');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
